import React from "react"
import Typography from "aldoo-ra/Typography"

/**
 * BrowserArticle Component
 * Renders a single article link in the help center browser
 */
const BrowserArticle = ({
  article,
  parentPath,
  level = 0,
  onArticleSelect,
  isActive,
  currentPath = {},
}) => {
  const indentationStyle = {
    paddingLeft: `${(level + 1) * 20 + 4}px`,
    // borderLeft: "1px solid #e5e7eb",
    marginLeft: "10px",
  }

  const handleArticleClick = (e) => {
    e.preventDefault()
    if (onArticleSelect) {
      onArticleSelect(article.slug, parentPath)
    }
  }

  return (
    <div style={indentationStyle} className="py-2">
      <button
        onClick={handleArticleClick}
        className="cursor-pointer p-0"
      >
        <Typography 
          variant="body1" 
          className={`text-left hover:text-primary my-0 
            ${ isActive ? "!text-primary" : "text-text"}`
          }
        >
          {article.label || article.slug.replace(/-/g, " ")}
        </Typography>

      </button>
    </div>
  )
}

export default BrowserArticle
